var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "editor-container",
      on: {
        "!mousedown": function($event) {
          return _vm.prepareFocusChange($event)
        },
        mousedown: _vm.commitFocusChange,
        "!touchstart": function($event) {
          return _vm.prepareFocusChange($event)
        },
        touchstart: _vm.commitFocusChange
      }
    },
    [
      !_vm.isPreview
        ? _c(
            "div",
            {
              staticClass: "editor-root",
              on: {
                dragenter: _vm.showDropPoint,
                dragover: function($event) {
                  $event.preventDefault()
                },
                drop: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "editor-left" },
                [
                  _c("div", { staticClass: "header" }, [
                    _c(
                      "div",
                      { staticClass: "header__group header__group--left" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "header-item header-ui header-ui--reactive tooltip-back",
                            attrs: { to: _vm.backTo }
                          },
                          [
                            _c("span", {
                              staticClass: "header-ui__icon fi-results"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "header-ui__text" }, [
                              _vm._v("記事管理へ")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "header-item header-ui header-ui--status-label"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("publishStatus")(_vm.gerberaContent)
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "header-item header-ui header-ui--saving saving-sign",
                            class: { "saving-sign--visible": _vm.isSaving }
                          },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("span", { staticClass: "saving-sign__text" }, [
                              _vm._v("保存中...")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "header__group header__group--right" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "header-item header-ui header-ui--reactive header-ui--colorless",
                            attrs: { disabled: !_vm.canUndo },
                            on: { click: _vm.undo }
                          },
                          [
                            _c("span", {
                              staticClass: "header-ui__icon fi-arrow-left"
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "header-ui__text header-ui__text"
                              },
                              [_vm._v("元に戻す")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "header-item header-ui header-ui--reactive header-ui--colorless",
                            attrs: { disabled: !_vm.canRedo },
                            on: { click: _vm.redo }
                          },
                          [
                            _c("span", {
                              staticClass: "header-ui__icon fi-arrow-right"
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "header-ui__text header-ui__text"
                              },
                              [_vm._v("やり直し")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("help-link", { attrs: { action: "editorFaq" } }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "header-item header-ui header-ui--reactive header-ui--colorless tooltip-help",
                              attrs: { href: "javascript:;" }
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "header-ui__icon header-ui__icon--animated el-icon-question icon-help"
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "header-ui__text header-ui__text"
                                },
                                [_vm._v("ヘルプ")]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "header-item header-ui header-ui--reactive header-ui--colorless tooltip-siteUrl",
                            attrs: { disabled: _vm.isNewArticle },
                            on: {
                              click: function($event) {
                                _vm.showSiteUrlDialog()
                              }
                            }
                          },
                          [
                            _c("span", {
                              staticClass:
                                "header-ui__icon header-ui__icon--animated fi-link"
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "header-ui__text header-ui__text"
                              },
                              [_vm._v("リンク取得")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "header-item header-ui header-ui--reactive header-ui--colorless tooltip-preview",
                            on: {
                              click: function($event) {
                                _vm.showPreview()
                              }
                            }
                          },
                          [
                            _c("span", {
                              staticClass:
                                "header-ui__icon header-ui__icon--animated fi-eye"
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "header-ui__text header-ui__text"
                              },
                              [_vm._v("プレビュー")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "header-item save-button-group",
                            class: {
                              "save-button-group--disabled":
                                _vm.alertMessageOnSave || _vm.isSaving
                            }
                          },
                          [
                            _vm.saveButtonType === "publishOrUpdate"
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "header-ui header-ui--reactive save-button-group__button save-button-group__button--main",
                                    on: { click: _vm.trackSaveButton }
                                  },
                                  [
                                    _c("span", { staticClass: "fi-upload" }),
                                    _vm._v(" "),
                                    _vm.isDraft
                                      ? _c("span", [_vm._v("公開")])
                                      : _c("span", [_vm._v("更新")])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.saveButtonType === "draft"
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "header-ui header-ui--reactive save-button-group__button save-button-group__button--main",
                                    on: { click: _vm.saveDraft }
                                  },
                                  [
                                    _c("span", { staticClass: "fi-pencil" }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("下書き保存")])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "click-document",
                                    rawName: "v-click-document",
                                    value: _vm.hideSaveDropdown,
                                    expression: "hideSaveDropdown"
                                  }
                                ],
                                staticClass:
                                  "save-button-group__button save-button-group__button--arrow",
                                on: { click: _vm.toggleSaveDropdown }
                              },
                              [
                                _vm._v("\n              ▼\n              "),
                                _c("span", { staticClass: "show-for-sr" }, [
                                  _vm._v("保存メニューを開く")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "transition",
                              { attrs: { name: "menu-transition" } },
                              [
                                _vm.isSaveDropdownVisible
                                  ? _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "save-button-group__menu save-menu"
                                      },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass: "save-menu__item",
                                            on: { click: _vm.trackSaveMenu }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "fi-upload"
                                            }),
                                            _vm._v(" "),
                                            _vm.isDraft
                                              ? _c("span", [_vm._v("公開")])
                                              : _c("span", [_vm._v("更新")])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass: "save-menu__item",
                                            on: { click: _vm.saveDraft }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "fi-pencil"
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("下書き保存")])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass: "save-menu__item",
                                            on: { click: _vm.showSaveDialog }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "fi-widget"
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("詳細設定 ...")])
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contents" }, [
                    _c("div", { staticClass: "contents__inner" }, [
                      _vm.isInitialized
                        ? _c(
                            "div",
                            { staticClass: "canvas" },
                            [
                              _c("article-vue", {
                                attrs: { id: _vm.articleId }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      ref: "scriptPool",
                      staticStyle: { display: "none" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("drop-marker")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tools" },
                [
                  _c("editor-menu", {
                    on: {
                      addText: _vm.addText,
                      addImage: _vm.addImage,
                      addEmbed: _vm.showEmbedDialog,
                      addUrl: _vm.showUrlDialog
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "loading-transition" } }, [
                _vm.isLoading
                  ? _c("div", { staticClass: "loading" }, [
                      _c("div", { staticClass: "overlay-messages" }, [
                        _c(
                          "div",
                          { staticClass: "overlay-messages__description" },
                          [
                            _vm._v(
                              "\n            記事を読み込み中です\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "overlay-messages__icon overlay-messages__icon--bound"
                          },
                          [_c("span", { staticClass: "fi-download" })]
                        )
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "overlay-transition" } }, [
                _vm.isDroppingImage
                  ? _c(
                      "div",
                      {
                        staticClass: "overlay-background",
                        on: {
                          dragover: _vm.readyAccept,
                          dragleave: _vm.hideDropPoint,
                          drop: _vm.handleDrop
                        }
                      },
                      [
                        _c("div", { staticClass: "drop-mark" }, [
                          _c("div", { staticClass: "overlay-messages" }, [
                            _c(
                              "div",
                              { staticClass: "overlay-messages__description" },
                              [
                                _vm._v("\n              ドロップして"),
                                _c("br"),
                                _vm._v(
                                  "\n              ファイルをアップロード\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "overlay-messages__icon overlay-messages__icon--bound"
                              },
                              [_c("span", { staticClass: "fi-photo" })]
                            )
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasLoadingError
                  ? _c("div", { staticClass: "overlay-background" }, [
                      _c("div", { staticClass: "loading-failed reveal" }, [
                        _c("p", [_vm._v("記事の読み込みに失敗しました。")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("通信環境をご確認のうえ、再度お試しください。")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "loading-failed__buttons" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "button large",
                                attrs: { to: _vm.backTo, tag: "button" }
                              },
                              [_vm._v("記事管理へ")]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isPrepareingToSave
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "escape-key",
                            rawName: "v-escape-key",
                            value: _vm.hideSaveDialog,
                            expression: "hideSaveDialog"
                          }
                        ],
                        staticClass: "overlay-background save-dialog",
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            return _vm.hideSaveDialog($event)
                          }
                        }
                      },
                      [
                        _c("publish-config", {
                          staticClass: "save-dialog__body reveal",
                          attrs: { articleData: _vm.saveDialogContent },
                          on: { submit: _vm.save, close: _vm.hideSaveDialog }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isPreparingToAddEmbed
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "escape-key",
                            rawName: "v-escape-key",
                            value: _vm.hideEmbedDialog,
                            expression: "hideEmbedDialog"
                          }
                        ],
                        staticClass: "overlay-background add-embed-dialog",
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            return _vm.hideEmbedDialog($event)
                          }
                        }
                      },
                      [
                        _c("embed-editor", {
                          staticClass: "add-embed-dialog__body reveal",
                          attrs: {
                            title: "埋め込みコードの追加",
                            submitLabel: "追加"
                          },
                          on: {
                            input: _vm.trackInputEmbedText,
                            submit: _vm.addEmbed,
                            close: _vm.hideEmbedDialog
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isPreparingToAddUrl
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "escape-key",
                            rawName: "v-escape-key",
                            value: _vm.hideUrlDialog,
                            expression: "hideUrlDialog"
                          }
                        ],
                        staticClass: "overlay-background add-url-dialog",
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            return _vm.hideUrlDialog($event)
                          }
                        }
                      },
                      [
                        _c("url-editor", {
                          staticClass: "add-url-dialog__body reveal",
                          attrs: { title: "URLの追加", submitLabel: "追加" },
                          on: {
                            input: _vm.trackInputUrlText,
                            submit: _vm.addUrl,
                            close: _vm.hideUrlDialog
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isPreparingToSiteUrl
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "escape-key",
                            rawName: "v-escape-key",
                            value: _vm.hideSiteUrlDialog,
                            expression: "hideSiteUrlDialog"
                          }
                        ],
                        staticClass: "overlay-background add-url-dialog",
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            return _vm.hideSiteUrlDialog($event)
                          }
                        }
                      },
                      [
                        _c("get-site-url", {
                          staticClass: "site-url-dialog__body reveal",
                          attrs: { siteUrlModel: _vm.siteUrlEvent },
                          on: {
                            input: function($event) {},
                            submit: _vm.hideSiteUrlDialog,
                            close: _vm.hideSiteUrlDialog
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _c("preview-vue", {
            on: {
              close: function($event) {
                _vm.hidePreview()
              }
            }
          }),
      _vm._v(" "),
      _vm.isExportContentVisible
        ? _c("html-generator", {
            staticClass: "html-generator",
            staticStyle: { display: "none" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("canvas", {
        staticStyle: { display: "none" },
        attrs: { id: "image-compressor" }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "saving-sign__icon" }, [
      _c("span", { staticClass: "fi-upload" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }